<template>
  <div class="minerve-step-one">
    <v-layout justify-center>
      <v-radio-group
        v-model="form.type"
        hide-details
        row
      >
        <v-radio
          label="MINERVE PLATRE"
          value="PLASTER_NECK_BRACE"
        />
        <v-radio
          label="MINERVE SCAN"
          value="SCAN_NECK_BRACE"
        />
      </v-radio-group>
    </v-layout>

    <h2 class="mt-6">
      POITRINE :
    </h2>
    <v-layout
      align-center
      mb-12
    >
      <v-flex sm3>
        <v-select
          v-model="form.chest"
          label="Taille"
          :items="chestItems"
          hide-details
          filled
          clearable
        />
      </v-flex>
      <v-flex sm3>
        <v-checkbox
          v-model="form.idc_sagging_chest"
          label="TOMBANTE"
          hide-details
          class="mt-0 ml-4"
          :disabled="!form.chest"
        />
      </v-flex>
    </v-layout>

    <v-layout
      justify-space-between
      mt-12
    >
      <v-flex
        column
        sm5
      >
        <v-switch
          v-model="form.idc_exterior_finishing"
          hide-details
          label="Finition Extérieure :"
          class="title"
          @change="clearExtFields"
        />
        <v-layout mb-4>
          <v-radio-group
            v-model="form.exterior_finishing_type"
            hide-details
            row
            :disabled="!form.idc_exterior_finishing"
          >
            <v-radio
              label="PE"
              value="PE"
            />
            <v-radio
              label="PP"
              value="PP"
            />
          </v-radio-group>
        </v-layout>

        <v-text-field
          v-model="form.thickness_external_finish"
          v-validate="'numeric|max:4'"
          data-vv-name="(Finition Ext)"
          :class="{ error: errors.has('(Finition Ext)') }"
          hide-details
          type="number"
          label="mm"
          outlined
          clearable
          class="mb-4"
          :disabled="!form.idc_exterior_finishing"
        />
        <v-text-field
          v-model="form.other_external_finish"
          label="Autre"
          outlined
          clearable
          hide-details
          class="mb-4"
          :disabled="!form.idc_exterior_finishing"
        />
        <v-layout class="color-select">
          <v-select
            v-model="form.transfer_id"
            label="TRANSFERT"
            filled
            clearable
            hide-details
            :items="transferColors"
            item-text="label"
            item-value="id"
            :disabled="!form.idc_exterior_finishing"
          />
          <template v-if="imagePreview">
            <v-flex
              v-if="imagePreview.texture == 'TEXTURE'"
              class="preview"
              style="width: 35px; height: 35px"
            >
              <img
                :src="imagePreview.image"
                style="width: 100%; height:100%"
                alt
              >
            </v-flex>
            <v-flex
              v-else-if="imagePreview.texture == 'COLOR'"
              class="preview"
              :style="{ 'background-color': '#' + imagePreview.rgb_code }"
            />
          </template>
        </v-layout>
      </v-flex>
      <v-flex
        column
        sm5
      >
        <v-switch
          v-model="form.idc_interior_finishing"
          hide-details
          label="Finition Intérieure :"
          class="title"
          @change="clearIntFields"
        />
        <v-layout mb-4>
          <v-radio-group
            v-model="form.interior_finishing_type"
            hide-details
            row
            :disabled="!form.idc_interior_finishing"
          >
            <v-radio
              label="PLASTA"
              value="PLASTA"
            />
            <v-radio
              label="EVA"
              value="EVA"
            />
          </v-radio-group>
        </v-layout>
        <v-text-field
          v-model="form.other_internal_finish"
          label="Autre"
          outlined
          clearable
          hide-details
          class="mb-8"
          :disabled="!form.idc_interior_finishing"
        />
        <p>Épaisseur :</p>
        <v-text-field
          v-model="form.thickness_internal_finish"
          v-validate="'numeric|max:4'"
          data-vv-name="(Finition Int)"
          :class="{ error: errors.has('(Finition Int)') }"
          hide-details
          type="number"
          label="mm"
          outlined
          clearable
          class="mt-2"
          :disabled="!form.idc_interior_finishing"
        />
      </v-flex>
    </v-layout>

    <v-textarea
      v-model="form.comment"
      filled
      name="Commentaires"
      label="Commentaires"
      value
      class="mt-12"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MinerveStepOne",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      transfers: [],
      chestItems: [
        { text: "FAIBLE", value: "SMALL" },
        { text: "MOYENNE", value: "MEDIUM" },
        { text: "FORTE", value: "STRONG" }
      ]
    };
  },
  computed: {
    ...mapGetters({
      transferColors: "colors/getTRANSFERType"
    }),

    // Get texture
    imagePreview() {
      return this.transferColors.find(item => item.id == this.form.transfer_id);
    }
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    // Clean ext fields
    clearExtFields() {
      this.form.exterior_finishing_type = null;
      this.form.transfer_id = null;
      this.form.thickness_external_finish = null;
      this.form.other_external_finish = null;
    },

    // Clean int fields
    clearIntFields() {
      this.form.interior_finishing_type = null;
      this.form.thickness_internal_finish = null;
      this.form.other_internal_finish = null;
    }
  }
};
</script>

<style lang="scss"></style>
